/**
 * Node modules
 */
import styled from 'styled-components';

/**
 * Private modules
 */
import { scale } from '../.private';

/**
 * Styled components
 */
export default styled.div`
  align-items: center;
  display: flex;
  svg:not(:first-child) {
    margin-left: ${scale.minor(1)}px;
  }
`;
